import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.js';
import './i18n/index.js';
// Inter lokaal (SIL OFL 1.1, node_modules/@fontsource/inter/LICENSE) — 400/500/600 volgens Kordaro v4.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import './index.css';
import { startServiceWorker } from './core/pwa/swUpdate.js';

// Service worker (offline) + nieuwe versie na een deploy meteen gebruiken
startServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
